import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store';
import axios from 'axios';
import * as echarts from 'echarts';
import { Button,Container, Header, Aside, Main, Menu, MenuItem, Submenu, Card, Image,Form,FormItem,Input, Dropdown,DropdownMenu,DropdownItem,
  Row,Col,Table,TableColumn,Pagination, Drawer,Divider,Select, Option, Cascader,DatePicker, RadioGroup,Tooltip, Radio, Dialog, Upload,
  Message,Tree,PageHeader,MessageBox,Loading,Badge,Descriptions, DescriptionsItem, Popover,Carousel, CarouselItem, Popconfirm } from 'element-ui';

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$message = Message;

Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Card);
Vue.use(Image);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Drawer);
Vue.use(Divider);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(Upload);
Vue.use(Tree);
Vue.use(PageHeader);
Vue.use(DatePicker);
Vue.use(Tooltip);
Vue.use(Loading);
Vue.use(Badge);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Popover);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Popconfirm);

Vue.prototype.$confirm = MessageBox.confirm;

// 路由守卫
router.beforeEach((to, from, next) => {
  // 如果没有登录信息 直接退出
  const localUser = JSON.parse(window.localStorage.getItem('iid-user-info'));
  let permissions = [];
  if(to.meta.permissions !== 'common') {
    if (localUser === null || localUser === undefined) {
      MessageBox.alert('用户登录信息已失效，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      }).then(() => {
        router.replace('/login');
      });
      return;
    }
    permissions = localUser.userType === 1 ?
        ['callForSubmissions', 'designReworkedInfo', 'systemManage'] : ['solicitationPage'];
    if(!permissions.includes(to.meta.permissions)) {
      MessageBox.alert('您没有该模块的访问权限，请登录正确的账号', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      }).then(() => {
        router.replace('/login');
        next();
      })
      return;
    }
    next();
  }
  next();
});
export default new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
